import { AffixProps, Affix as AntdAffix } from "antd";
import React from "react";

const Affix = (props: AffixProps) => {
  return <AntdAffix {...props} />;
};

export default Affix;
